import Button from "@acko-tech/building-blocks.ui.button-old";
import { $white, Box, styled } from "@acko-tech/building-blocks.ui.common";

export const BUTTON_SUCCESS = "#0FA457";
export const BUTTON_DISABLED = "#C8D0DB";

export const Container = styled.div``;

export const InnerContainer = styled.div`
  @media (min-width: 768px) {
    display: flex;
    padding: 40px 0 60px 0;
  }
`;

export const Heading = styled.div`
  color: #0a0a0a;
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.1px;
  padding: 10px 0 12px;
  @media (min-width: 768px) {
    flex: 0.75;
    padding: 60px 80px;
    text-align: left;
  }
`;

export const HeadingText = styled.span`
  color: #0a0a0a;
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.1px;
  @media (min-width: 768px) {
    color: var(--text-base-Primary, rgba(0, 0, 0, 0.88));
    font-family: "Euclid Circular B";
    font-size: 44px;
    font-style: normal;
    font-weight: 600;
    line-height: 56px;
    letter-spacing: -0.5px;
  }
`;

export const HighlightedText = styled.span`
  color: #5018dc;
  font-family: "Euclid Circular B";
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.1px;
  @media (min-width: 768px) {
    color: #5018dc;
    font-family: "Euclid Circular B";
    font-size: 44px;
    font-style: normal;
    font-weight: 600;
    line-height: 56px;
    letter-spacing: -0.5px;
  }
`;

export const ScrollableContainer = styled.div`
  overflow-x: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  @media (min-width: 768px) {
    flex: 1;
    overflow-y: hidden;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CardsWrapper = styled.div`
  margin: 20px 20px;
  display: flex;
  flex-direction: row;
  width: max-content;
  height: 100%;
  gap: 16px;
`;

export const ButtonContainer = styled.div`
  display: block;
  margin: 20px;
  @media (min-width: 768px) {
    margin: 0px;
  }
`;

export const ConfirmButton = styled(Button)`
  padding: ${(props: any) => props.padding};
  background: ${(props: any) => (props.disable ? BUTTON_SUCCESS : $white)};
  border-radius: 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: ${(props: any) => (props.disable ? $white : "#000")};
  border: none;
  outline: none;
  cursor: pointer;
  border: ${(props: any) =>
    props.disable ? "none" : `1px solid var(--line-primary-n-200, #E7E7F0);`};
  width: ${(props: any) => props.width};
  height: 48px;
  ${(props) => props.styles}
  &:hover {
    background: ${(props: any) => (props.disable ? BUTTON_SUCCESS : $white)};
    border: ${(props: any) => (props.disable ? "none" : `1px solid #000`)};
    color: ${(props: any) => (props.disable ? $white : "#000")};
  }
  @media (min-width: 768px) {
    height: 60px;
  }
`;

export const CardContainer = styled.div`
  width: 235px;
  height: 234px;
  padding: var(--spacing-20px, 20px) 0 0 var(--spacing-spacing-8, 16px);
  border-radius: 16px;
  border: 1px solid var(--Border-Default-grey100, #e8e8e8);
  background: #f5f6ff;
  backdrop-filter: blur(16px);
  position: relative;
  overflow: hidden;
  @media (min-width: 768px) {
    width: 411px;
    height: 370px;
    padding: var(--Dimensions-Space-spacing-32, 32px) 0 0
      var(--Dimensions-Space-spacing-32, 32px);
    border-radius: 40px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    gap: 12px;
    margin-bottom: 24px;
  }
`;

export const CardUserInfoWrapper = styled.div``;

export const CardUserInfo = styled.div`
  color: var(--Text-Primary-grey600, #121212);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  padding: 0 0 2px 0;
  @media (min-width: 768px) {
    color: var(--text-base-Primary, rgba(0, 0, 0, 0.88));
    font-family: "Euclid Circular B";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: -0.1px;
  }
`;

export const CardUserAction = styled.div`
  color: var(--Text-Secondary-grey400, #4b4b4b);
  font-family: "Euclid Circular B";
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  @media (min-width: 768px) {
    color: var(--Neutral-N400, #5b5675);
    font-family: "Euclid Circular B";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const PriceSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const PriceWrapper = styled.div``;

export const PriceLabel = styled.div`
  color: #040222;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  margin-bottom: 4px;
  @media (min-width: 768px) {
    color: #040222;
    font-family: "Euclid Circular B";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: -0.1px;
  }
`;

export const PriceValue = styled.div`
  color: #000;
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  @media (min-width: 768px) {
    color: #000;
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 44px;
    letter-spacing: -0.1px;
  }
`;

export const SavingsTag = styled.div`
  align-self: flex-end;
  text-align: center;
  padding: 4px 8px;
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  background: #d8ffe5;
  border-radius: 8px;
  border: 1px solid rgba(0, 155, 90, 0.4);
  color: #066325;
  @media (min-width: 768px) {
    text-align: center;
    font-family: "Euclid Circular B";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    transform: translateY(-8px);
  }
`;

export const DealerPriceSection = styled.div`
  margin-top: 16px;
  @media (min-width: 768px) {
    margin-top: 24px;
  }
`;

export const DealerPriceLabel = styled.div`
  color: var(--Text-Secondary-grey400, #4b4b4b);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 4px;
  @media (min-width: 768px) {
    color: var(--Text-Secondary-grey400, #4b4b4b);
    font-family: "Euclid Circular B";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: -0.1px;
  }
`;

export const DealerPriceValue = styled.div`
  color: #121212;
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  @media (min-width: 768px) {
    color: #121212;
    font-family: "Euclid Circular B";
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px;
    letter-spacing: -0.1px;
  }
`;

export const CardImageWrapper = styled.div`
  position: absolute;
  bottom: 0;
  right: -40px;
  @media (min-width: 768px) {
    right: -80px;
  }
`;

export const NavigationControls = styled.div`
  display: flex;
  gap: 9.6px;
`;

export const NavigationButton = styled.div<{ rotate?: boolean }>`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  gap: 9.6px;
  border-radius: 38.4px;
  border: 1px solid var(--line-primary-n-200, #e7e7f0);
  background: var(--background-secondary-n-50, #f8f7fc);
  transform: ${(props) => (props.rotate ? "rotate(180deg)" : "none")};
  cursor: pointer;
`;

export const UserAvatar = styled.div`
  border: 1px solid #e7e7f0;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
